










































import {
  defineComponent,
  onMounted,
  useRoute,
  useContext,
  ref,
  ssrRef,
  useFetch,
  watch
} from '@nuxtjs/composition-api';
import { SfHeading, SfButton } from '@storefront-ui/vue';
import { useSveaOrder } from '@wemade-vsf/payment-svea';
import { useCart } from '@wemade-vsf/customer';
import { useEvent } from '@wemade-vsf/composables';
import SkeletonLoader from 'components/theme/SkeletonLoader.vue';
import type { SveaOrder, CustomerOrder } from '@wemade-vsf/magento-api';

export default defineComponent({
  name: 'CheckoutConfirmation',
  layout: 'checkout',
  components: {
    SfHeading,
    SfButton,
    SkeletonLoader
  },
  setup () {
    const { app } = useContext();
    const route = useRoute();
    const { confirmOrder, error: sveaError } = useSveaOrder();
    const { load: loadCart, setCart, cart } = useCart(); 
    const sveaHash = ref<string | null>(null);
    const sveaOrder = ssrRef<SveaOrder | null>(null);
    const orderNumber = ssrRef<string>('');
    const magentoOrder = ssrRef<CustomerOrder | null>(null);
    const loaded = ref(false);
    const loading = ref(false);

    useFetch(async() => {      
      if (route.value.query?.hash) {
        sveaHash.value = Array.isArray(route.value.query.hash) ? route.value.query.hash[0] : route.value.query.hash || ''
        sveaOrder.value = await confirmOrder(sveaHash.value ?? '');

        if (!sveaError.value.confirmOrder && sveaOrder.value?.MagentoOrder) {
          magentoOrder.value = sveaOrder.value?.MagentoOrder;
          orderNumber.value = magentoOrder.value?.number ?? '';
        }
      }
    })

    async function clearCart() {
      if (loading.value) return;
      loading.value = true;
      if (magentoOrder.value) {
        useEvent('order:placed', magentoOrder.value)
      }
      setCart(null);
      app.$vsf.$magento.config.state.removeCartId();
      await loadCart({ realCart: true });
      loading.value = false;
      loaded.value = true
    }

    onMounted(async () => {
      if (sveaOrder.value) {
        await clearCart();
      }
    })

    watch (() => sveaOrder.value, async () => {
      if (!loading.value && !!sveaOrder.value) {
        await clearCart();
      }
    })

    return {
      sveaHash,
      orderNumber,
      sveaOrder,
      loaded
    }
  }
})
